import { render } from "./ColumnsPage.vue?vue&type=template&id=f995d582"
import script from "./ColumnsPage.vue?vue&type=script&lang=js"
export * from "./ColumnsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__